import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Button, Form, Input, Select } from 'antd';
import { ValuationRejectReason } from '../../../interfaces';
import { Formik, FormikProps, FormikValues } from 'formik';
import * as yup from 'yup';
import { ExclamationCircleFilled } from '@ant-design/icons';

const formSchema = yup.object().shape({
  reason: yup.string().required('Заавал оруулах'),
  note: yup.string().required('Заавал оруулах'),
});

type Props = {
  reasons: ValuationRejectReason[];
  type: 'reject' | 'returned';
  onSubmit: (values: FormikValues) => Promise<any>;
};

export type RejectFormRef = {
  submit: () => Promise<any>;
  getValues: () => any;
};

const RejectForm = forwardRef<RejectFormRef, Props>(({ reasons, onSubmit, type }, ref) => {
  console.log('RejectForm => reasons :', reasons);
  const formikRef = useRef<FormikProps<FormikValues>>(null);

  useImperativeHandle(ref, () => ({
    submit: async () => {
      return await formikRef.current?.submitForm();
    },
    getValues: () => formikRef.current?.values || {},
  }));

  return (
    <Formik
      initialValues={{ reason: undefined, note: '' }}
      validationSchema={formSchema}
      onSubmit={(values) => {
        onSubmit(values);
      }}
      innerRef={formikRef}
    >
      {({ values, setFieldValue, handleSubmit, errors, touched }) => {
        return (
          <div>
            <div className="flex flex-row items-center">
              <div className="font-[600] text-[#000000D5] text-[14px] flex items-center">
                <ExclamationCircleFilled
                  style={{ color: type === 'reject' ? '#E53935' : '#FFA726', fontSize: '16px' }}
                />
                <span className="ml-[4px]">{type === 'reject' ? 'Татгалзах' : 'Буцаах'}</span>
              </div>
            </div>

            <div className="h-[15px]" />

            <Form layout="vertical" onFinish={handleSubmit} className="form">
              <Form.Item
                name="reason"
                label="Гарчиг"
                validateStatus={errors.reason && touched.reason ? 'error' : ''}
                help={typeof errors.reason === 'string' && touched.reason ? errors.reason : ''}
              >
                <Select
                  options={reasons.map((e) => ({ label: e.name, value: e.code }))}
                  placeholder="Гарчиг"
                  value={values.reason}
                  onChange={(e) => setFieldValue('reason', e)}
                  status={errors.reason && touched.reason ? 'error' : ''}
                />
              </Form.Item>

              <Form.Item
                name="note"
                label={type === 'reject' ? 'Татгалзах шалтгаан' : 'Буцаах шалтгаан'}
                validateStatus={errors.note && touched.note ? 'error' : ''}
                help={typeof errors.note === 'string' && touched.note ? errors.note : ''}
              >
                <Input.TextArea
                  name="note"
                  rows={4}
                  placeholder={type === 'reject' ? 'Татгалзах шалтгаан' : 'Буцаах шалтгаан'}
                  value={values.note}
                  onChange={(e) => setFieldValue('note', e.target.value)}
                />
              </Form.Item>
            </Form>
          </div>
        );
      }}
    </Formik>
  );
});

export { RejectForm };
